import SessionManagerRecord, { SessionManagerRecordSource } from '../lib/SessionManagerRecord.js';
import RoleType from './RoleType.js';
import ApplicationUser from './ApplicationUser.js';
/**
 * @property {RoleType} role
 * @property {string} scope
 * @property {?number} scopePk
 * @property {ApplicationUser} user
 */
class RoleUser extends SessionManagerRecord {
    initialize(props) {
        super.initialize(props);
        this.user = new ApplicationUser(props.user);
        this.createdAt = new Date(props.createdAt);
        this.expiredAt = props.expiredAt && new Date(props.expiredAt);
    }
    /**
     * @type {boolean}
     */
    get isOrganizationScope() {
        return this.scope.includes('api/org/v1/organizations');
    }
    /**
     * @type {boolean}
     */
    get isUniversal() {
        return this.scopePk === null;
    }
    /**
     * @type {boolean}
     */
    get isUniversalOrganization() {
        return this.isUniversal && this.isOrganizationScope;
    }
    /**
     * @type {boolean}
     */
    get isActive() {
        var _a, _b, _c;
        const hasDate = !!this.expiredAt;
        // Permissions that don't expire are always active
        if (!hasDate)
            return true;
        // Permissions with an invalid date are expired
        const hasValidDate = hasDate && ((_a = this.expiredAt) === null || _a === void 0 ? void 0 : _a.toString()) !== 'Invalid Date';
        // Permissions that expire in the future are active
        return hasValidDate && ((_c = (_b = this.expiredAt) === null || _b === void 0 ? void 0 : _b.valueOf()) !== null && _c !== void 0 ? _c : 0) > Date.now();
    }
    /**
     * @type {boolean}
     */
    get isExpired() {
        return !this.isActive;
    }
    /**
     * @param {number} userID
     * @param {object} [params]
     * @return {Promise<RoleUser[]>}
     */
    static async allForUser(userID, params = {}) {
        return RoleUser.all({ ...params, user: userID });
    }
    /**
     * @param {number} organizationID
     * @param {object} [params]
     * @return {Promise<RoleUser[]>}
     */
    static async allForOrganization(organizationID, params = {}) {
        return RoleUser.all({ ...params, orgId: organizationID });
    }
}
RoleUser.RoleUser = RoleUser;
RoleUser.RoleType = RoleType;
RoleUser.ROLE_VALUE_MAP = {
    [RoleType.DASHBOARD]: 5,
    [RoleType.DASHBOARD_TRIAL]: 4,
    [RoleType.WHEREHOUSE]: 3,
    [RoleType.SEEK]: 2,
    [RoleType.SEEK_TRIAL]: 1,
};
RoleUser.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
};
export default RoleUser;
